import React, { useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData, updateDocumentByID } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'

//? Material-ui
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import { IconButton } from '@material-ui/core'

export default function DealerOnboardingRequests() {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  let { data: dealers, isLoading } = useQuery(['dealer-requests', debouncedValue && debouncedValue], () => getAllData('/dealer', { searchQuery: debouncedValue }))

  const queryClient = useQueryClient()

  const handleAcceptRequest = async (id, data) => {
    const { levelName, status } = data
    const response = await updateDocumentByID('/dealer', id, { levelName, status })
    console.log(response)
    queryClient.invalidateQueries('dealer-requests')
  }

  let tmpArr = []
  if (!isLoading && dealers?.data?.length > 0) {
    dealers.data.map((item) => {
      return tmpArr.push([
        { type: 'CHECKBOX', _id: item?._id },
        { value: item?.name },
        { value: item?.email },
        { value: `${item.countryCode??"+91 "} ${item.phone}`},
        { value: formatDate(item.createdAt) },
        ...item.levelStatus.map((level) => {
          let rejectPopup = false
          return {
            value: (
              <>
                {level.status === 'IN_PROGRESS' ? (
                  <>
                    <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleAcceptRequest(item?._id, { levelName: level.levelName, status: 'APPROVED' })}>
                      <CheckIcon style={{ color: 'blue' }} />{' '}
                    </IconButton>

                    <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleAcceptRequest(item?._id, { levelName: level.levelName, status: 'DENIED' })}>
                      <ClearIcon style={{ color: 'red' }} />{' '}
                    </IconButton>
                  </>
                ) : null}
                {level.status === 'APPROVED' ? (
                  <>
                    <p>APPROVED</p>
                  </>
                ) : null}
                {level.status === 'DENIED' ? (
                  <>
                    <p>DENIED</p>
                  </>
                ) : null}
              </>
            ),
          }
        }),
      ])
    })
  }

  const layoutProps = {
    heading: 'Dealer Onboarding Requests',
    url: ROUTES.ADD_DEALER_ONBOARDING,
    editUrl: 'dealer-onboarding-requests/edit/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    permissionName: 'ORDER',
    // tempHeaders: tempHeaders,
    // tempHeaderData: [],
    // filename: 'moduleAdmins',
    // sampleName: 'sample_moduleAdmins',
    // sheetName: 'moduleAdmin',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('/dealer', id)
    }
    queryClient.invalidateQueries('dealer-onboarding')
    window.location.reload()
  }

  return (
    <CustomTableLayout
      tableHeadings={["Dealer's Name", 'Email', 'Phone', 'Created At', 'LEVEL-1', 'LEVEL-2', 'LEVEL-3', 'LEVEL-4', 'LEVEL-5']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      // handlePageChange={handleChange}
      // paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
